/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState } from "react";
import styles from './pdf-download.css';
import { useLocalNotificationBanner, useTranslation } from "Shared/util/custom-hooks";
import InlineSvg from "../inline-svg";
import Spinner from "../spinner";
import { fetchPayoutSpecificationPdf } from "Shared/util/web-api";

type PdfDownloadProps = {
    transactionId: number;
};

export const PdfDownload: FC<PdfDownloadProps> = ({transactionId}) => {
    const t = useTranslation(x => x.transactions);
    const ts = useTranslation((x) => x.edit_payment_information.messageCodes);
    const [loading, setLoading] = useState(false);
    const { NotificationBannerType, addLocalNotificationBanner } = useLocalNotificationBanner(false);

    const handleDownloadPdf = () => {
        setLoading(true);
        
        fetchPayoutSpecificationPdf(transactionId)
            .then((result: any) => {
                const a = document.createElement("a");
                a.href = result.contentUrl;
                a.download = result.contentUrl;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch(() => {
                addLocalNotificationBanner(ts.SIGNING_UNSUCCESSFUL, NotificationBannerType.Error);
            })
            .finally(() => setLoading(false));
    }

    return (
        <div className={styles.pdfDownloadContainer}>
            {loading ? <Spinner /> : (
                <a onClick={handleDownloadPdf}>
                    <InlineSvg src="/download.svg" />{t.pdf}
                </a>
            )}
        </div>  
    );
};
